import api from "!../../../../../../releases/cc1c9e0b9de53852dd2b7a84f8c79a40bbceffed/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/cc1c9e0b9de53852dd2b7a84f8c79a40bbceffed/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/cc1c9e0b9de53852dd2b7a84f8c79a40bbceffed/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/cc1c9e0b9de53852dd2b7a84f8c79a40bbceffed/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};